var $dd982288a17d1ada$exports = {};
$dd982288a17d1ada$exports = {
    "info": `Bilgiler`,
    "negative": `Hata`,
    "positive": `Ba\u{15F}ar\u{131}l\u{131}`
};


export {$dd982288a17d1ada$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
